export default "__VITE_ASSET__D$04vJF___"